import React from "react";
import styled from "styled-components";
import lookup from "country-code-lookup";

import "../../node_modules/flag-icons/css/flag-icons.min.css";

interface FlagProps {
  item: string;
}

function Flag({ item }: FlagProps) {
  return (
    <Container>
      <span className={`fi fi-${item.toLocaleLowerCase()}`}></span>
      <Iso>{lookup.byIso(item).country}</Iso>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
`;

const Iso = styled.span`
  display: flex;
  margin-left: 1rem;
  align-items: center;
`;

export default Flag;
